import { render, staticRenderFns } from "./OffsetPagination.vue?vue&type=template&id=720156a4&"
import script from "./OffsetPagination.vue?vue&type=script&lang=ts&"
export * from "./OffsetPagination.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports